export class FilterModel {

	// Filter
	public filter = {
		Schriftgutverwaltung: {
			Aktenzeichen: '',
			Vorgangskennung: '',
			Adresskennung: '',
			vonDatum: '',
			bisDatum: ''
		},
		Aktenplanverwaltung: {
			Aktenzeichen: ''
		},
		VorgangsVerwaltung: {
			Aktenzeichen: '',
			Adresskennung: ''
		},
		Adressverwaltung: {
			Vorname: '',
			Nachname: '',
			Strasse: '',
			StrOrt: ''
		},
		Sitzungsverwaltung: {
			vonDatum: '',
			bisDatum: ''
		}
	};

	// Forms
	public Schriftgutverwaltung = [
		{
			label: 'Aktenzeichen',
			name: 'Aktenzeichen',
			type: 'text',
			placeholder: '123.123.123',
			value: ''
		}, {
			label: 'Teilakte/Vorgang-Kennung',
			name: 'Vorgangskennung',
			type: 'text',
			placeholder: '123.123.123',
			value: ''
		}, {
			label: 'Adresskennung',
			name: 'Adresskennung',
			type: 'text',
			placeholder: 'Adresskennung',
			value: ''
		}, {
			label: 'Von',
			name: 'vonDatum',
			type: 'date',
			placeholder: 'TT.MM.JJJJ',
			value: ''
		}, {
			label: 'Bis',
			name: 'bisDatum',
			type: 'date',
			placeholder: 'TT.MM.JJJJ',
			value: ''
		}
	];

	public Aktenplanverwaltung = [
		{
			label: 'Aktenzeichen',
			name: 'Aktenzeichen',
			type: 'text',
			placeholder: '123.123.123',
			value: ''
		}
	];

	public VorgangsVerwaltung = [
		{
			label: 'Aktenzeichen',
			name: 'Aktenzeichen',
			type: 'text',
			placeholder: '123.123.123',
			value: ''
		}, {
			label: 'Adresskennung',
			name: 'Adresskennung',
			type: 'text',
			placeholder: 'Adresskennung',
			value: ''
		}
	];

	public Adressverwaltung = [
		{
			label: 'Vorname',
			name: 'Vorname',
			type: 'text',
			placeholder: '',
			value: ''
		}, {
			label: 'Nachname',
			name: 'Nachname',
			type: 'text',
			placeholder: '',
			value: ''
		}, {
			label: 'Strasse',
			name: 'Strasse',
			type: 'text',
			placeholder: '',
			value: ''
		}, {
			label: 'Ort',
			name: 'StrOrt',
			type: 'text',
			placeholder: '',
			value: ''
		}
	];

	public Sitzungsverwaltung = [
		{
			label: 'Von',
			name: 'vonDatum',
			type: 'date',
			placeholder: 'TT.MM.JJJJ',
			value: ''
		}, {
			label: 'Bis',
			name: 'bisDatum',
			type: 'date',
			placeholder: 'TT.MM.JJJJ',
			value: ''
		}
	];


}
